import { render, staticRenderFns } from "./TextField.vue?vue&type=template&id=257240f4&scoped=true&"
import script from "./TextField.vue?vue&type=script&lang=js&"
export * from "./TextField.vue?vue&type=script&lang=js&"
import style0 from "./TextField.vue?vue&type=style&index=0&id=257240f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257240f4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseInputField: require('/vercel/path0/components/ui/forms/BaseInputField.vue').default})
